import FormInputTypes from '../components/atoms/formEnums/formInputTypes';

export default {
  attributeName: 'interactableTabs',
  isDragable: false,
  canOpen: false,
  canEdit: true,
  canCreate: true,
  canRemove: true,
  emptyMessage: "You don't have any Interactable Tabs. Add one by clicking on the +new button.",
  fields: [
    {
      attributeName: 'name',
      label: 'Name',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      helpText: 'Display name of the tab that will appear in the Canvas.',
      placeholder: 'e.g. Standings',
      default: '',
      canEdit: true,
      canCreate: true,
      class: 'col-sm-4',
      exactWidth: '30%',
    },
    {
      attributeName: 'url',
      label: 'URL',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      helpText: 'Destination URL that will open when the tab is clicked.',
      placeholder: 'https://example.com',
      default: '',
      canEdit: true,
      canCreate: true,
      hasTooltip: true,
      class: 'col-sm-8',
      exactWidth: '50%',
    },
  ],
};